module.exports = __webpack_public_path__ + "img/symbol_8.a0c51d9b.png";